import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CalendarStateFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CalendarStateFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.0144 20.4645H5.63673C3.90732 20.4645 2.5 19.0649 2.5 17.3445V6.73862C2.5 5.01825 3.90732 3.61867 5.63673 3.61867H17.0158C18.7452 3.61867 20.1525 5.01825 20.1525 6.73862V10.421C20.1525 11.085 19.6111 11.623 18.9438 11.623C18.2766 11.623 17.7352 11.085 17.7352 10.421V6.73862C17.7352 6.34349 17.4126 6.0227 17.0158 6.0227H5.63672C5.2399 6.0227 4.91732 6.34349 4.91732 6.73862V17.3445C4.91732 17.7396 5.23989 18.0604 5.63672 18.0604H9.01439C9.68166 18.0604 10.2231 18.5984 10.2231 19.2625C10.2231 19.9266 9.68167 20.4645 9.0144 20.4645Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.8996 9.62579H3.75292C3.08564 9.62579 2.54425 9.08787 2.54425 8.42377C2.54425 7.75968 3.08564 7.22175 3.75292 7.22175H18.8996C19.5669 7.22175 20.1082 7.75968 20.1082 8.42377C20.1082 9.08787 19.5668 9.62579 18.8996 9.62579Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.0346 6.0227C14.3673 6.0227 13.8259 5.48477 13.8259 4.82068V3.20202C13.8259 2.53792 14.3673 2 15.0346 2C15.7019 2 16.2433 2.53792 16.2433 3.20202V4.82068C16.2433 5.48477 15.7019 6.0227 15.0346 6.0227Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.61789 6.0227C6.95061 6.0227 6.40922 5.48477 6.40922 4.82068V3.20202C6.40922 2.53792 6.95061 2 7.61789 2C8.28517 2 8.82656 2.53792 8.82656 3.20202V4.82068C8.82656 5.48477 8.28517 6.0227 7.61789 6.0227Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2123 22C13.2506 22 10.8407 19.6028 10.8407 16.657C10.8407 14.0143 12.8223 11.7413 15.4496 11.3687C16.1105 11.2855 16.7227 11.7335 16.8161 12.3898C16.91 13.047 16.4508 13.6553 15.7899 13.7492C14.3462 13.9527 13.258 15.2036 13.258 16.657C13.258 18.2776 14.5832 19.596 16.2123 19.596C17.6098 19.596 18.8273 18.6101 19.1071 17.2506C19.2418 16.6012 19.885 16.1865 20.5336 16.3146C21.1876 16.4476 21.609 17.0834 21.4752 17.7338C20.9658 20.2053 18.7526 22 16.2123 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2536 18.3949C15.9335 18.3949 15.6257 18.2688 15.399 18.0428L14.5842 17.232C14.1121 16.7626 14.1126 16.0017 14.5847 15.5322C15.0282 15.0911 15.7299 15.0637 16.2049 15.453L18.3788 13.0568C18.8263 12.5638 19.5895 12.5247 20.0856 12.9697C20.5813 13.4138 20.6206 14.1737 20.1736 14.6666L17.151 17.9979C16.9287 18.2424 16.6155 18.3861 16.2846 18.394C16.2743 18.3949 16.2639 18.3949 16.2536 18.3949Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CalendarStateFalseIcon;
